// extracted by mini-css-extract-plugin
module.exports = {"back":"backButton_back__3JICy"};